<template>
  <HubContainer id="posConfigurationHub">

    <template v-if="moduleActivated.POS && atLeastCompanyAdmin">
      <HubSection large icon="icon/hub/printing.svg"
                  :title="$t('printers.title')"
                  :description="$t('printers.description')"
                  :buttonAction="goToPrinters">
      </HubSection>

      <HubSection large icon="icon/hub/printing-groups.svg"
                  :title="$t('printer_groups.title')"
                  :description="$t('printer_groups.subtitle')"
                  :buttonAction="goToPrinterGroup">
      </HubSection>

      <HubSection large icon="icon/hub/receipt-design.svg"
                  :title="$t('receipt_config.header_title')"
                  :description="$t('receipt_config.header_description')"
                  :buttonAction="goToReceipt">
      </HubSection>
    </template>

  </HubContainer>
</template>

<script>
  import HubSection from "@/components/HubSection";
  import HubContainer from "@/components/HubContainer";

  export default {
    name: "posPrinterHub",

    components: { HubSection, HubContainer },

    async mounted() {
      this.$store.state.pageTitleTranslationKey = "printers.printing";
      this.$store.state.pageIcon = "/icon/printer.svg";

      if (this.$route.query.branch) {
        let branchModule = await this.$store.getters.getContextBranchActivatedModule;
        Object.assign(this.moduleActivated, branchModule);
      }

      if (this.$route.query.company) {
        let companyModule = await this.$store.getters.getContextCompanyActivatedModule;
        Object.assign(this.moduleActivated, companyModule);
      }
    },

    data() {
      return {
        moduleActivated: {
          onlineOrdering: false,
          kiosk: false,
          mobileApp: false,
          menuBoard: false,
          loyalty: false,
          thirdPartyLoyalty: false,
          aimsVouchers: false,
          onSiteOrdering: false,
          payAtTheTable: false,
          catering: false,
          dispatch: false,
          POS: false,
        }
      }
    },

    computed: {
      atLeastCompanyAdmin() {
        return this.$store.getters.loggedUserHasCompanyAdmin;
      },
    },

    methods: {
      goToPrinterGroup() {
        this.$router.push(this.$router.buildContext("/printer-groups"));
      },
      goToPrinters() {
        this.$router.push(this.$router.buildContext("/printers"));
      },
      goToReceipt() {
        this.$router.push(this.$router.buildContext("/receipt-configuration"));
      },
    }
  }
</script>